import React from "react";
import {
  Card,
  CardContent,
  FormControl,
  CircularProgress,
  Typography,
  RadioGroup,
  Table,
  Radio,
  useMediaQuery,
  FormControlLabel,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Box,
} from "@mui/material";
import styles from "./BrandAnalysisStatus.module.css";
import ArrowUpwardIcon from "../../../assets/images/ArrowUpwardIcon_green.svg";
import ArrowDownwardIcon from "../../../assets/images/ArrowDownwardIcon_red.svg";
import { useSalesContext } from "../../SalesContext";

const BrandAnalysisStatus = ({ limitedView = false, theadiing }) => {
  const { kpiData, salesUnit, unit, setUnit, loading, selectedMRs } =
    useSalesContext();

  console.log(unit);
  const data = {
    card1: kpiData?.kpi_data?.Card1 || [],
    card2: kpiData?.kpi_data?.Card2 || [],
  };

  const columnsCard1 = ["", "LYTD", "Target", "CYTD", "%Ach", "Grw"];

  const columnsCard2 = limitedView
    ? ["", "LYTD", "CYTD"]
    : ["", "LYTD", "Target", "CYTD", "%Ach", "Grw"];

  const isDataEmpty =
    !kpiData || data.card1.length === 0 || data.card2.length === 0;

  const RenderTable = ({ tableData, title, contentClass, columns }) => {
    const processedData = tableData?.map((row) => {
      const newRow = { ...row };
      columns.forEach((col) => {
        let dataKey;
        if (col === "%Ach") {
          dataKey = unit === "Units" ? "PercentageAch_Qty" : "PercentageAch";
        } else if (col === "Grw") {
          dataKey = unit === "Units" ? "Growth_Qty" : "Growth";
        } else if (col !== "" && col !== "Brand") {
          dataKey = unit === "Units" ? `${col}_Qty` : col;
        } else {
          dataKey = col;
        }

        if (col !== "" && col !== "Brand" && col !== "%Ach" && col !== "Grw") {
          let numValue = parseFloat(newRow[dataKey]);

          if (
            isNaN(numValue) ||
            numValue === Infinity ||
            numValue === -Infinity ||
            newRow[dataKey] === null ||
            newRow[dataKey] === undefined
          ) {
            numValue = 0;
          }

          let adjustedValue = numValue;

          const isCard2 = title === theadiing || columns === columnsCard2;
          if (!(isCard2 && limitedView)) {
            if (salesUnit === "Lacs") {
              adjustedValue = numValue / 100000;
            } else if (salesUnit === "Crores") {
              adjustedValue = numValue / 10000000;
            }
          }

          newRow[dataKey] = adjustedValue.toFixed(2);
        }
      });
      return newRow;
    });
    const isCard2 = title === theadiing || columns === columnsCard2;
    const displayTitle =
      isCard2 && limitedView ? title : `${title} (${salesUnit})`;
    const isBelow900px = useMediaQuery("(max-width:900px)");
    return (
      <Card className={styles.card}>
        <CardContent className={contentClass}>
          <Typography className={styles.cardTitle}>{displayTitle}</Typography>
          <Table size="small" className={styles.table}>
            <TableHead>
              <TableRow>
                {columns.map((col, i) => (
                  <TableCell
                    key={col}
                    className={
                      i === 0 ? styles.tableHeadCellEmpty : styles.tableHeadCell
                    }
                  >
                    {col}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {processedData.map((row, i) => (
                <TableRow key={i}>
                  {columns.map((col, j) => {
                    let dataKey;
                    if (col === "%Ach") {
                      dataKey =
                        unit === "Units"
                          ? "PercentageAch_Qty"
                          : "PercentageAch";
                    } else if (col === "Grw") {
                      dataKey = unit === "Units" ? "Growth_Qty" : "Growth";
                    } else if (col !== "" && col !== "Brand") {
                      dataKey = unit === "Units" ? `${col}_Qty` : col;
                    } else {
                      dataKey = col;
                    }

                    if (col === "%Ach" || col === "Grw") {
                      const value = parseFloat(row[dataKey]) || 0;
                      const isNegative = value < 0 && value !== 0;
                      const isPositive = value > 0;

                      const formattedValue = `${value.toFixed(2)}%`;
                      return (
                        <TableCell key={col} className={styles.tableBodyCell}>
                          <Box display="flex" alignItems="center">
                            {isNegative && (
                              <img
                                src={ArrowDownwardIcon}
                                alt="Down"
                                style={{
                                  width: isBelow900px ? 12 : 16,
                                  marginRight: isBelow900px ? 3 : 4,
                                }}
                              />
                            )}
                            {isPositive && (
                              <img
                                src={ArrowUpwardIcon}
                                alt="Up"
                                style={{
                                  width: isBelow900px ? 12 : 16,
                                  marginRight: isBelow900px ? 3 : 4,
                                }}
                              />
                            )}
                            <Typography
                              component="span"
                              style={{
                                color: isNegative
                                  ? "#FF0000"
                                  : isPositive
                                  ? "#008000"
                                  : "inherit",
                                fontSize: isBelow900px ? "10px" : "14px",
                              }}
                            >
                              {formattedValue}
                            </Typography>
                          </Box>
                        </TableCell>
                      );
                    }
                    const isCard2 =
                      title === theadiing || columns === columnsCard2;
                    const isPercentageColumn =
                      (col === "LYTD" || col === "CYTD") &&
                      isCard2 &&
                      limitedView;
                    const displayValue = isPercentageColumn
                      ? `${row[dataKey]}%`
                      : row[dataKey];
                    return (
                      <TableCell
                        key={col}
                        className={
                          j < 4
                            ? styles.tableBodyCellBold
                            : styles.tableBodyCell
                        }
                      >
                        {col === "" ? row.Brand : displayValue}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    );
  };

  if (loading ) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          minHeight: "300px",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box className={styles.container}>
      <Box className={styles.header}>
        <Typography className={styles.headerTitle}>
          Brand Analysis STATUS
        </Typography>
      </Box>
      <Box className={styles.toggleButtonGroup}>
        <Typography className={styles.mrStrength}>
          MR Strength{" "}
          <strong className={styles.mrStrengthStrong}>
            (Active + VACANT): {selectedMRs}
          </strong>
        </Typography>
        <FormControl component="fieldset">
          <RadioGroup
            value={unit}
            onChange={(e) => setUnit(e.target.value)}
            className={styles.radioGroup}
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <FormControlLabel
              value="Units"
              control={<Radio size="small" className={styles.radioButton} />}
              label={
                <Typography className={styles.radioButtonlabel}>
                  Units
                </Typography>
              }
              className={styles.radioLabel}
            />
            <FormControlLabel
              value="Value"
              control={<Radio size="small" className={styles.radioButton} />}
              label={
                <Typography className={styles.radioButtonlabel}>
                  Value
                </Typography>
              }
              className={styles.radioLabel}
            />
          </RadioGroup>
        </FormControl>
      </Box>
      <Box className={styles.cardsContainer}>
        <RenderTable
          tableData={data.card1}
          title="TOP 3 Brand Sale Wise"
          contentClass={styles.cardContentSales}
          columns={columnsCard1}
        />
        <RenderTable
          tableData={data.card2}
          title={theadiing}
          contentClass={styles.cardContentGrowth}
          columns={columnsCard2}
        />
      </Box>
    </Box>
  );
};

export default BrandAnalysisStatus;
